import React from "react";
import UsersCommon from "../UsersMain";

const CancellationRequests = () => {
  const type = "Cancellation_Requests";
  const title = "Cancellation Requests";
  return <UsersCommon type={type} title={title} />;
};

export default CancellationRequests;
